import axios from 'axios';
import { getHostname } from './server/server'

const hostname = getHostname();
const authPath = '/v2/auth';

const loginUser = async (username, password) => {
    const res = await axios.post(`${hostname}${authPath}/login`, { username, password });
    return res.data;
}

const authorizeAdmin = async (pin) => {
    const res = await axios.post(`${hostname}${authPath}/authorizeAdmin`, { pin });
    return res.data;
}

const logoutUser = async () => {
    await axios.post(`${hostname}${authPath}/logout`);
    window.location.reload();
}

const loginWithMicrosoft = () => {
    window.location.href = `${hostname}/v2/microsoft/login`;
}

const signUpWithMicrosoft = (signUpRequestId) => {
    window.location.href = `${hostname}/v2/microsoft/signup?signUpRequestId=${signUpRequestId}`;
}

export {
    loginUser,
    authorizeAdmin,
    logoutUser,
    loginWithMicrosoft,
    signUpWithMicrosoft
}